<template>
  <base-wrapper>
    <div class="space-y-4">
      <base-card
        title="Tambah Pengiriman Ekspedisi"
        description="Tambah pengiriman ekspedisi"
      >
        <div class="border-t pt-5">
          <base-input
            inset
            label="Nama Ekspedisi"
            disabled
            :value="officeExpedition.data.attributes.name"
            placeholder="Nama ekspedisi"
          />
        </div>
      </base-card>

      <base-card
        title="Pilih Pengiriman"
        description="Pilih daftar pengiriman yang akan dikirim"
      >
        <div class="border-t pt-5">
          <datatable :columns="columns">
            <template #tbody="{ classes }">
              <tr
                v-for="stockMovement in stockMovements.data"
                :key="stockMovement.id"
                :class="[classes.tr]"
              >
                <td :class="[classes.td]">
                  <base-checkbox
                    :input-value="stockMovement.id"
                    v-model="selectedOfficeExpeditions"
                  />
                </td>
                <td :class="[classes.td]">
                  <p class="font-bold text-gray-900">
                    {{ stockMovement.attributes.code }}
                  </p>
                </td>
                <td :class="[classes.td]">
                  {{ stockMovement.attributes.grand_total_weight | toFixed }}
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </base-card>

      <div class="flex justify-end">
        <base-button
          :disabled="disabledSave"
          @click="visibleSaveConfirm = true"
        >
          <Icon icon="heroicons:truck-solid" />
          Simpan
        </base-button>
      </div>
    </div>

    <base-confirm
      :visible="visibleSaveConfirm"
      icon-type="badge"
      type="success"
      title="Konfirmasi Pengiriman"
      message="Apakah anda yakin ingin membuat pengiriman ekspedisi ini?"
      @close="visibleSaveConfirm = false"
      @confirmed="onSave"
    />

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';
import BaseCheckbox from '../../../../components/base/BaseCheckbox.vue';
import BaseConfirm from '../../../../components/base/BaseConfirm.vue';

export default {
  components: {
    BaseCheckbox,
    BaseConfirm,
  },
  mixins: [requestMixin],
  data() {
    return {
      loading: false,
      officeExpedition: {
        data: {
          attributes: {},
        },
      },
      stockMovements: {
        data: [],
      },
      selectedOfficeExpeditions: [],
      visibleSaveConfirm: false,
    };
  },
  computed: {
    columns() {
      return [
        { id: 'check', name: '' },
        { id: 'code', name: 'Kode Kemasan' },
        { id: 'weight', name: 'Total Berat' },
      ];
    },
    disabledSave() {
      return this.selectedOfficeExpeditions.length < 1;
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadOfficeExpedition() {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/office-expeditions/${this.$route.params.id}`,
        {
          params: {
            'fields[office-expeditions]': 'name',
          },
        }
      );

      if (!err) {
        this.officeExpedition = res;

        await this.loadStockMovements();
      }

      this.loading = false;
    },
    async loadStockMovements() {
      const [res, err] = await this.request(
        `/api/v1/office-expeditions/${this.$route.params.id}/stock-movements`,
        {
          params: {
            'filter[available_for_schedule_pickup]': 'true',
            'fields[stock-movements]': 'code,grand_total_weight',
          },
        }
      );

      if (!err) {
        this.stockMovements = res;
      }
    },
    async onSave() {
      this.visibleSaveConfirm = false;
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/office-expeditions/${this.$route.params.id}/-actions/create-shipment`,
        {
          method: 'post',
          data: {
            stock_movement_ids: this.selectedOfficeExpeditions,
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Pengiriman ekspedisi berhasil dibuat',
        });

        this.$router.push({ name: 'pengiriman-ekspedisi' });
      }

      this.loading = false;
    },
  },
  created() {
    this.loadOfficeExpedition();
  },
};
</script>
